/**
 * Le tappe e i conti del ciclo di vita, nelle parole della lingua scelta.
 *
 * Il servizio manda un nome italiano e un'identita' stabile: si traduce per
 * identita', e il nome resta il ripiego per un'identita' che la pagina non
 * conosce ancora — meglio una riga in italiano che una riga vuota.
 */
import type { MessageKey } from './i18n/messages'
import type { Count, Stage } from './types'

const STAGE_KEY: Record<string, MessageKey> = {
  reception: 'lifecycle.stage.reception',
  integrity: 'lifecycle.stage.integrity',
  georeferencing: 'lifecycle.stage.georeferencing',
  cloud: 'lifecycle.stage.cloud',
  detection: 'lifecycle.stage.detection',
  ready: 'lifecycle.stage.ready',
}

const COUNT_KEY: Record<string, MessageKey> = {
  objects: 'lifecycle.count.objects',
  bytes: 'lifecycle.count.bytes',
  frames: 'lifecycle.count.frames',
  located: 'lifecycle.count.located',
  dated: 'lifecycle.count.dated',
  bound: 'lifecycle.count.bound',
  spans: 'lifecycle.count.spans',
  measured: 'lifecycle.count.measured',
  gauged: 'lifecycle.count.gauged',
  predicted: 'lifecycle.count.predicted',
  waiting: 'lifecycle.count.waiting',
}

export function stageName(t: (key: MessageKey) => string, stage: Stage): string {
  const key = stage.id === undefined ? undefined : STAGE_KEY[stage.id]
  return key === undefined ? stage.name : t(key)
}

export function countName(t: (key: MessageKey) => string, count: Count): string {
  const key = count.key == null ? undefined : COUNT_KEY[count.key]
  return key === undefined ? count.what : t(key)
}

const NOTE_KEY: Record<string, MessageKey> = {
  outside_uploader: 'lifecycle.noteOutsideUploader',
}

export function stageNote(t: (key: MessageKey) => string, stage: Stage): string | null {
  if (stage.note == null) return null
  const key = stage.note_id == null ? undefined : NOTE_KEY[stage.note_id]
  return key === undefined ? stage.note : t(key)
}
